import { render, staticRenderFns } from "./Password ResetSent.vue?vue&type=template&id=a3c457b6&scoped=true"
import script from "./Password ResetSent.vue?vue&type=script&lang=js"
export * from "./Password ResetSent.vue?vue&type=script&lang=js"
import style0 from "./Password ResetSent.vue?vue&type=style&index=0&id=a3c457b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c457b6",
  null
  
)

export default component.exports